"use strict";

import { slugify } from "../utilities";
import AppModel from '../App/model.js';

// show alert message
const showAlert = AppModel.showAlert;

export default class Filters {

    // update the query string with the selected filters
    static updateQueryString($form) {

        // update rooms filter in query string
        const $roomsInput = $('input[name="pieces_number[]"]:checked');
        if($roomsInput.length !== 0){
            var selectedRooms = [];
            $roomsInput.each(function() {
                selectedRooms.push($(this).val());
            });
            selectedRooms = selectedRooms.join(',');
        }

        // update energy class filter in query string
        const $energyClassInput = $('input[name="energy_class[]"]:checked');
        if($energyClassInput.length !== 0){
            var selectedEnergyClass = [];
            $energyClassInput.each(function() {
                selectedEnergyClass.push($(this).val());
            });
            selectedEnergyClass = selectedEnergyClass.join(',');
        }
    
        // update bedrooms filter in query string
        const $bedroomsInput = $('input[name="chambers_number[]"]:checked');
        if($bedroomsInput.length !== 0){
            var selectedBedrooms = [];
            $bedroomsInput.each(function() {
                selectedBedrooms.push($(this).val());
            });
            selectedBedrooms = selectedBedrooms.join(',');
        }

        // update facilities filter in query string
        const $facilitiesInput = $('input[name="facility[]"]:checked');
        if($facilitiesInput.length !== 0){
            var selectedFacilities = [];
            $facilitiesInput.each(function() {
                selectedFacilities.push($(this).val());
            });
            selectedFacilities = selectedFacilities.join(',');
        }

        // update keywords filter in query string
        const $keywordsInput = $('input[name="keywords[]"]');
        if($keywordsInput.length !== 0){
            var keywords = [];
            $keywordsInput.each(function() {
                keywords.push($(this).val());
            });
            keywords = keywords.join(',');
        }

        // update real estate types filter in query string
        const $realEstateTypesInput = $('input[name="realestate_type[]"]:checked');
        if($realEstateTypesInput.length !== 0){
            var selectedRealEstateTypes = [];
            $realEstateTypesInput.each(function() {
                selectedRealEstateTypes.push($(this).val());
            });
            selectedRealEstateTypes = selectedRealEstateTypes.join(',');
        }

        // update locations filter in query string
        const $locationsInput = $('input[name="locations[]"]');
        if($locationsInput.length !== 0){
            var locations = [];
            $locationsInput.each(function() {
                locations.push($(this).val());
            });
            locations = locations.join(',');
        }

        // update ad type filter in query string
        const adType = $('input[name="ad_type"]:checked').val();
    
        // Serialize the form
        let formQueryString = $form.serialize();
    
        // Split the query string into key-value pairs
        let pairs = formQueryString.split('&');

        // hidden of form inputs in URL
        const hiddenFormInputKeys = [
            'pieces_number[]',
            'chambers_number[]',
            'energy_class[]',
            'facility[]',
            'keywords[]',
            'locations[]',
            'realestate_type[]',
            'ad_type'
        ];
    
        // Filter out pairs with empty values
        let filteredPairs = pairs.filter(function (pair) {
            let parts = pair.split('=');
            // Check if the value part is not empty and the key isn't included in hidden form inputs
            return parts[1] !== '' &&
            !hiddenFormInputKeys.includes(decodeURIComponent(parts[0]));
        });
    
        // Join the filtered pairs back into a query string
        formQueryString = filteredPairs.join('&');
    
        // Add the selected rooms and bedrooms to the query string
        if(selectedRooms !== undefined && selectedRooms !== ''){
            formQueryString += `&rooms=${selectedRooms}`;
        }
        if(selectedBedrooms !== undefined && selectedBedrooms !== ''){
            formQueryString += `&bedrooms=${selectedBedrooms}`;
        }

        // Add the selected energy class to the query string
        if(selectedEnergyClass !== undefined && selectedEnergyClass !== ''){
            formQueryString += `&energy_class=${selectedEnergyClass}`;
        }

        // Add the selected facilities to the query string
        if(selectedFacilities !== undefined && selectedFacilities !== ''){
            formQueryString += `&facilities=${selectedFacilities}`;
        }

        // Add the keywords to the query string
        if(keywords !== undefined && keywords !== ''){
            formQueryString += `&keywords=${keywords}`;
        }

        // sanitized query for URL in browser 
        const urlQueryString = formQueryString;

        // Add the selected real estate types to the query string
        if(selectedRealEstateTypes !== undefined && selectedRealEstateTypes !== ''){
            formQueryString += `&real_estate_types=${selectedRealEstateTypes}`;
        }

        // Add the selected locations to the query string
        if(locations !== undefined && locations !== ''){
            formQueryString += `&locations=${locations}`;
        }
        
        // Add the selected ad type to the query string
        formQueryString += `&ad_type=${adType ?? 'sell'}`;

        return {
            formQueryString,
            urlQueryString
        };
    }

    // update the path parameters of the real estate search URL with the selected filters [ adType, locations, realEstateTypes ]
    static updateRealEstateSearchPathParams( baseUrl, $form) {

        let path = baseUrl;
        // prepare locations path param
        const $locationsInput = $form.find('input[name="locations[]"]');
        if($locationsInput.length !== 0){
            var locations = [];
            $locationsInput.each(function() {
                locations.push(slugify($(this).val()));
            });
            locations = locations.sort().join(',');
        }

        // prepare realEstateTypes path param
        const $realEstateTypesInput = $form.find('input[name="realestate_type[]"]:checked');
        if($realEstateTypesInput.length !== 0){
            var selectedRealEstateTypes = [];
            $realEstateTypesInput.each(function() {
                selectedRealEstateTypes.push($(this).val());
            });
            selectedRealEstateTypes = selectedRealEstateTypes.sort().join(',');
        }

        // prepare adType path param
        const $adTypeInput = $form.find('input[name="ad_type"]:checked');
        const adType = $adTypeInput.val() == 'sell' ? 'vente' : 'location'; // show the french translation in URL path param

        if(adType !== undefined && adType !== null){
            path += `/${adType}`;
        }else{
            path += '/vente';
        }

        // Add the locations to the path
        if(locations !== undefined && locations !== ''){
            path += `/${locations}`;
        }else{
            path += '/france';
        }

         // Add the selected real estate types to the path
        if(selectedRealEstateTypes !== undefined && selectedRealEstateTypes !== ''){
            path += `/${selectedRealEstateTypes}`;
        }

        return  encodeURI(path);
    }

    static mirrorValueToHtml(input){ 
        // Set the value of the input to the value of its 'data-value' attribute
        var dataValue = $(input).val(); 
        $(input).attr('data-value', dataValue);            
    }

    static setStateRealEstateTypeFilter(type){

        const url = $('#types-dropdown').data('set-state-route');
        const data = {'realEstateType' : type};
        $.ajax({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            url,
            data,
            type: 'POST',
            success: function(response){
                // console.log(response.message);
            },
            error: function(error){
                console.log(error);
            }
        });
    }

    static resetStateRealEstateTypeFilter(){

        const url = $('#types-dropdown').data('reset-state-route');
        $.ajax({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            url,
            type: 'GET',
            success: function(response){
                // console.log(response.message);
            },
            error: function(error){
                console.log(error);
            }
        });
    }

    // sync filters and apply them from more filters modal to actual filters dropdowns
    static syncFiltersFromMobileToDesktop($form) {
        const $modal = $('#more-filters-modal');

        // validate the price
        const $maxPrice = $modal.find('#price_max_mobile');
        const $minPrice = $modal.find('#price_min_mobile');
        if (parseInt($maxPrice.val()) < parseInt($minPrice.val())) {
            showAlert($maxPrice.data('error-msg'), 'error');
            $modal.find('#price_min_mobile, #price_max_mobile').parent().removeClass('border-red-500');
            return;
        }

        // validate the space filter
        const $maxSpace = $modal.find('#space_max_mobile');
        const $minSpace = $modal.find('#space_min_mobile');
        if (parseInt($maxSpace.val()) < parseInt($minSpace.val())) {
            showAlert($maxSpace.data('error-msg') , 'error');
            $modal.find('#space_min_mobile, #space_max_mobile').parent().removeClass('border-red-500');
            return;
        }

        // get checked inputs from more filters modal
        const $checkedRooms = $modal.find('input[name="pieces_number_mobile[]"]:checked');
        const $checkedBedrooms = $modal.find('input[name="chambers_number_mobile[]"]:checked');
        const $checkedEnergyClass = $modal.find('input[name="energy_class_mobile[]"]:checked');
        const $checkedFacilities = $modal.find('input[name="facility_mobile[]"]:checked');
        const checkedListedBy = $modal.find('input[name="listed_by_mobile"]:checked');
        const isFirstOwnerChecked = $modal.find('input[name="is_first_owner_mobile"]').is(':checked');
        const $keywords = $modal.find('input[name="keywords_mobile[]"]');

        // sync rooms filter
        const $roomsFilter = $form.find('#pieces-dropdown');
        $roomsFilter.find('input[name="pieces_number[]"]').prop('checked', false);
        $checkedRooms.each(function(){
            const roomValue = $(this).val();
            $roomsFilter.find(`input[name="pieces_number[]"][value="${roomValue}"]`).prop('checked', true);
        });

        // sync bedrooms filter
        const $bedroomsFilter = $form.find('#bedrooms-filter');
        $bedroomsFilter.find('input[name="chambers_number[]"]').prop('checked', false);
        $checkedBedrooms.each(function(){
            const bedroomValue = $(this).val();
            $bedroomsFilter.find(`input[name="chambers_number[]"][value="${bedroomValue}"]`).prop('checked', true);
        });

        // sync energy class filter
        const $energyClassFilter = $form.find('#energy-class-filter');
        $energyClassFilter.find('input[name="energy_class[]"]').prop('checked', false);
        $checkedEnergyClass.each(function(){
            const energyClassValue = $(this).val();
            $energyClassFilter.find(`input[name="energy_class[]"][value="${energyClassValue}"]`).prop('checked', true);
        });

        // sync facilities filter
        const $facilitiesFilter = $form.find('#facilities-filter');
        $facilitiesFilter.find('input[name="facility[]"]').prop('checked', false);
        $checkedFacilities.each(function(){
            const facilityValue = $(this).val();
            $facilitiesFilter.find(`input[name="facility[]"][value="${facilityValue}"]`).prop('checked', true);
        });

        // sync listed by filter
        const $listedByFilter = $form.find('#listed-by-filter');
        $listedByFilter.find('input[name="listed_by"]').prop('checked', false);
        if(checkedListedBy.length > 0){
            const listedByValue = checkedListedBy.val();
            $listedByFilter.find(`input[name="listed_by"][value="${listedByValue}"]`).prop('checked', true);
        }

        // sync is first owner filter
        const $isFirstOwnerFilter = $form.find('#first-owner-filter');
        $isFirstOwnerFilter.find('input[name="is_first_owner"]').prop('checked', false);
        if(isFirstOwnerChecked){
            $isFirstOwnerFilter.find('input[name="is_first_owner"]').prop('checked', true);
        }

        // sync keywords filter
        const $keywordsFilter = $form.find('#keywords-filter');
        $keywordsFilter.find('input[name="keywords[]"]').remove();
        $keywords.each(function(){
            const keywordValue = $(this).val();
            const $newKeywordInput = $('<input>')
                .attr('type', 'hidden')
                .attr('name', 'keywords[]')
                .val(keywordValue);
            $keywordsFilter.append($newKeywordInput);
        });

        // sync space filter
        const $spaceFilter = $form.find('#area-dropdown');
        $spaceFilter.find('#space_min').val($minSpace.val());
        $spaceFilter.find('#space_max').val($maxSpace.val());

        // sync price filter
        const $priceFilter = $form.find('#budget-dropdown');
        $priceFilter.find('#price_min').val($minPrice.val());
        $priceFilter.find('#price_max').val($maxPrice.val());

        // clear the keyword input in mobile more filters modal
        $("#keyword-input-mobile").val('');
    }

    static applyMobileFilters($form) {
        const $modal = $('#more-filters-modal');
        // get the web filter dropdown elements to sync
        const filterType = 'more-filter';
        const $filterDropdown = $form.find(`#${filterType}-dropdown`);
        const $filterDropdownButton = $filterDropdown.parent();

        const $maxSpace = $modal.find('#space_max_mobile');
        const $minSpace = $modal.find('#space_min_mobile');
        const $maxPrice = $modal.find('#price_max_mobile');
        const $minPrice = $modal.find('#price_min_mobile');

        // check if the filter is applied and reset the filter if it's empty
        if($modal.data('applied') == true) {
            const checkedInputs = $modal.find('input:checked').length;
            const keywordsInput = $modal.find('input[name="keywords[]"]').length;
            const zeroOrEmptyRegex = /^(0+)?$/;

            const testSpaceZeroOrEmpty = (zeroOrEmptyRegex.test($maxSpace.val()) && 
                (zeroOrEmptyRegex.test($minSpace.val())));

            const testPriceZeroOrEmpty = (zeroOrEmptyRegex.test($maxPrice.val()) && 
                (zeroOrEmptyRegex.test($minPrice.val())));

            if(checkedInputs === 0 
                && keywordsInput === 0
                && testSpaceZeroOrEmpty
                && testPriceZeroOrEmpty
            ) {
                $modal.data('applied', false);

                //reset budget and area filters values
                $maxPrice.val('');
                $minPrice.val('');
                $maxSpace.val('');
                $minSpace.val('');

                //style filter span and text when selected
                $filterDropdownButton
                    .find('> span')
                    .removeClass('bg-light-blue text-blue-brand')
                    .addClass('bg-slate-100');

                $filterDropdownButton
                    .find('> span svg.options-icon')
                    .attr('fill', '#0F2027');
            }
        }else {
            //trigger submit to update the results on listing page
            $modal.data('applied', true);

            //style filter span and text when selected
            $filterDropdownButton
                .find('> span')
                .removeClass('bg-slate-100')
                .addClass('bg-light-blue text-blue-brand');

            $filterDropdownButton
                .find('> span svg.options-icon')
                .attr('fill', '#3485FF');
        }

        // update the applied filters count in mobile view
        let appliedFiltersCountMobile = 0;
        const $appliedFiltersCountMobile = $('#applied-filters-count-mobile');

        // check each filter option in the more filters modal
        $('.filter-option-mobile').each(function(_, filterOptionMobile) {
            const $filterOptionMobile = $(filterOptionMobile);

            const $checkedInputs = $filterOptionMobile.find('input:checked');

            if($checkedInputs.length > 0) {
                $filterOptionMobile.data('applied', true);
                appliedFiltersCountMobile++;
            } else {
                $filterOptionMobile.data('applied', false);
            }
        });

        const $keywordsInputs = $modal.find('input[name="keywords[]"]');
        const $keywordsFilter = $modal.find('#keywords-filter-mobile');
        if($keywordsInputs.length === 0) {
            $keywordsFilter.data('applied', false);
        } else {
            $keywordsFilter.data('applied', true);
            appliedFiltersCountMobile++;
        }

        const $areaFilter = $modal.find('#area-filter-mobile');
        if($minSpace.val() !== '' || $maxSpace.val() !== '') {
            $areaFilter.data('applied', true);
            appliedFiltersCountMobile++;
        } else {
            $areaFilter.data('applied', false);
        }

        const $budgetFilter = $modal.find('#budget-filter-mobile');
        if($minPrice.val() !== '' || $maxPrice.val() !== '') {
            $budgetFilter.data('applied', true);
            appliedFiltersCountMobile++;
        } else {
            $budgetFilter.data('applied', false);
        }

        // update the applied filters count in mobile view badge
        if(appliedFiltersCountMobile){
            $appliedFiltersCountMobile.find('> span').text(appliedFiltersCountMobile);
            if($appliedFiltersCountMobile.hasClass('hidden')){
                $appliedFiltersCountMobile.addClass('flex justify-center items-center').removeClass('hidden');
            }
        } else {
            if($appliedFiltersCountMobile.hasClass('flex')){
                $appliedFiltersCountMobile.addClass('hidden').removeClass('flex justify-center items-center');
            }
            $appliedFiltersCountMobile.find('> span').text(0);
        }
    }

    static resetMobileFilters($form) {
        const $modal = $('#more-filters-modal');
        const $inputs = $modal.find('input');
        // get the web filter dropdown elements to sync
        const filterType = 'more-filter';
        const $filterDropdown = $form.find(`#${filterType}-dropdown`);
        const $filterDropdownButton = $filterDropdown.parent();

        const $bedroomsInput = $modal.find('input[name="chambers_number_mobile[]"]');
        const $appliedFiltersCountMobile = $('#applied-filters-count-mobile');


        $inputs.each(function (_, input) {
            const $input = $(input);
            if ($input.attr('type') === 'checkbox' || $input.attr('type') === 'radio') {
                $input.prop('checked', false);
            } else if ($input.attr('name') === 'keywords[]') {
                $input.remove();
            } else {
                $input.val('');
            }
        });

        $('#keyword-input-mobile').attr('placeholder', 'E.g').prop('disabled', false);
        $('.keyword-mobile').remove();

        //reset the bedrooms filter based on the selected rooms
        $bedroomsInput.prop('disabled', false);
        $bedroomsInput.next()
            .removeClass('border-gray-200 text-gray-200 cursor-not-allowed')
            .addClass('text-gray-800 border-gray-400 cursor-pointer');

        // reset the applied filters count in mobile view badge
        if($appliedFiltersCountMobile.hasClass('flex')){
            $appliedFiltersCountMobile.addClass('hidden').removeClass('flex justify-center items-center');
        }
        $appliedFiltersCountMobile.find('> span').text(0);

        $modal.data('applied', false);
        $modal.find('.filter-option-mobile').data('applied', false);

        //style filter span and text when selected
        $filterDropdownButton
            .find('> span')
            .removeClass('bg-light-blue text-blue-brand')
            .addClass('bg-slate-100');

        $filterDropdownButton
            .find('> span svg.options-icon')
            .attr('fill', '#0F2027');
    }
}